
export default function iofferModule() {
  const segmentButtons = jQuery('.ioffer-segments button');
  const ioffersButtons = jQuery('.ioffers a');

  function setActiveSegment(segment) {
    segment = segment || 'all';
    if (segment == 'all') {
      segmentButtons.removeClass('inactive');
      ioffersButtons.show();
    } else {
      segmentButtons.each((i, elem) => {
        const button = jQuery(elem);
        if (button.attr('data-segment') === 'all') return;
        if (button.attr('data-segment') === segment) button.removeClass('inactive');
        else button.addClass('inactive');
      });
      ioffersButtons.each((i, elem) => {
        const button = jQuery(elem);
        if (button.attr('data-segment') === segment) button.show();
        else button.hide();
      });
    }
  }

  segmentButtons.click(e => {
    const elem = jQuery(e.target);
    const button = elem.is('button') ? elem : elem.parent('button');
    setActiveSegment(button.attr('data-segment'));
  });

  /*
   *  Set Modal section
   */
  window.setModalSection = function setModalSection(activeSection) {
    $('section[data-section=\'download\']').each((i, elem) => {
      const section = jQuery(elem);
      const link = $("<a>")
        .text("download")
        .attr("href", section.attr('data-pdf'))
        .attr("target", "_blank");
      section.append(link);
    });
    $('.ioffer-modal nav > button').each((i, elem) => {
      const button = jQuery(elem);
      if (activeSection === button.attr('data-section')) button.addClass('active');
      else button.removeClass('active');
    });
    $('.ioffer-modal section').each((i, elem) => {
      const section = jQuery(elem);
      if (activeSection === section.attr('data-section')) section.addClass('active');
      else section.removeClass('active');
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ioffer.js